module.exports = __webpack_public_path__ + "static/media/SahneDokumu.0beab932.png";